import React from "react";
import { WaveMark } from "./WaveMark";
import { VILLA } from "../data";
import { scrollToId } from "./Navbar";

export default function Footer() {
    return (
        <footer className="bg-[#0C131D] text-white pt-16 pb-8" data-testid="footer">
            <div className="max-w-7xl mx-auto px-5 lg:px-8">
                <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
                    <div>
                        <div className="flex items-center gap-3">
                            <WaveMark size={40} />
                            <span className="font-serif-d text-xl">Fernandina Shores <span className="text-[#C49A45]">#6322</span></span>
                        </div>
                        <p className="mt-4 text-white/50 text-sm leading-relaxed max-w-xs">
                            A premium three-bedroom coastal retreat on Amelia Island — three minutes from the sand.
                        </p>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.25em] text-[#C49A45] font-semibold mb-4">Explore</p>
                        <div className="grid grid-cols-2 gap-2 text-sm">
                            {[["Overview", "overview"], ["Gallery", "gallery"], ["Amenities", "amenities"], ["Experiences", "experiences"], ["Availability", "availability"], ["Location", "location"], ["Policies", "policies"], ["Contact", "contact"]].map(([label, id]) => (
                                <button key={id} onClick={() => scrollToId(id)} className="text-left text-white/60 hover:text-white transition-colors" data-testid={`footer-link-${id}`}>{label}</button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.25em] text-[#C49A45] font-semibold mb-4">Reach the host</p>
                        <p className="text-white/60 text-sm">{VILLA.address}</p>
                        <p className="text-white/60 text-sm mt-2">{VILLA.phone}</p>
                        <p className="text-white/60 text-sm mt-1">{VILLA.email}</p>
                    </div>
                </div>
                <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
                    <p data-testid="footer-copyright">© {new Date().getFullYear()} Fernandina Shores #6322 · Amelia Island, Florida</p>
                    <p>Provider rates change frequently — always confirm the live total and cancellation terms before booking.</p>
                </div>
            </div>
        </footer>
    );
}
